/** Frontend API wrapper for payroll overview data. */

import { API_BASE, getAuthHeaders } from '../utils/supabase/client';
import type { PayrollOverview } from '../types/payroll';
import { readError } from './_http';

export class PayrollService {
  static async getOverview(workspaceId: string): Promise<PayrollOverview> {
    const p = new URLSearchParams({ workspaceId });
    const res = await fetch(`${API_BASE}/payroll/overview?${p}`, {
      headers: await getAuthHeaders(),
    });
    if (!res.ok) throw new Error(await readError(res));
    return res.json();
  }
}
